class Utils {
  // 随机数
  randomNumber(n = 3) {
    return Math.floor(Math.random() * n);
  }
  // 转时间
  dateComputed(date) {
    return new Date(date || Date.now()).toLocaleDateString().replace(/\//g, ".");
  }
  // 转时间
  timeComputed(times) {
    const now = times ? new Date(times) : new Date();
    return ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2);
  }
  // 转时间
  timestamp(times) {
    const now = times ? new Date(times) : new Date();

    const year = now.getFullYear();
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const day = ("0" + now.getDate()).slice(-2);
    const hours = ("0" + now.getHours()).slice(-2);
    const minutes = ("0" + now.getMinutes()).slice(-2);
    const seconds = ("0" + now.getSeconds()).slice(-2);

    const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedTime;
  }
  formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  formatTimeDiff(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffInSeconds = Math.floor((end - start) / 1000);

    const hours = Math.floor(diffInSeconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((diffInSeconds / 60) % 60)
      .toString()
      .padStart(2, "0");
    const seconds = (diffInSeconds % 60).toString().padStart(2, "0");

    if (hours > 0) {
      return `${hours}:${minutes}:${seconds}`;
    }
    return `${minutes}:${seconds}`;
  }

  // 计算高度偏移量
  getHeightOffset(current, base) {
    return current - base;
  }

  // 计算高度比例（百分比）
  getHeightRatio(partial, total) {
    if (total === 0) return 0;
    // if (total === 0) throw new Error("总高度不能为零");
    return (partial / total) * 100;
  }

  // 计算相对高度
  getRelativeHeight(h1, h2) {
    return h1;
    // return Math.abs(h1 - h2);
  }

  // 综合计算方法
  calculateAll(base, current) {
    return {
      offset: this.getHeightOffset(current, base),
      ratio: this.getHeightRatio(current, base),
      relative: this.getRelativeHeight(current, base),
    };
  }

  // 速度计算
  calculateSpeed(point1, point2) {
    // 地球半径(米)
    const R = 6371000;

    // 角度转弧度
    const toRad = (deg) => (deg * Math.PI) / 180;

    // 计算水平距离(Haversine公式)
    const φ1 = toRad(point1.position.latitude);
    const φ2 = toRad(point2.position.latitude);
    const Δφ = toRad(point2.position.latitude - point1.position.latitude);
    const Δλ = toRad(point2.position.longitude - point1.position.longitude);

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const groundDistance = R * c;

    // 计算高度差
    const altitudeDiff = Math.abs(point2.position.altitude - point1.position.altitude);

    // 计算三维空间直线距离(勾股定理)
    const realDistance = Math.sqrt(groundDistance ** 2 + altitudeDiff ** 2);

    // 计算时间差(秒)
    const timeDiff = ((+point2.timestamp || +point2.Time) - (+point1.timestamp || +point1.Time)) / 1000;

    // 返回速度(米/秒)
    return timeDiff > 0 ? realDistance / timeDiff : 0;
  }

  // 方向判断
  calculateBearing(basePoint, targetPoint) {
    const [lng1, lat1] = basePoint.map(Number);
    const [lng2, lat2] = targetPoint.map(Number);

    // 转换为弧度
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δλ = ((lng2 - lng1) * Math.PI) / 180;

    // 计算方向角
    const y = Math.sin(Δλ) * Math.cos(φ2);
    const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
    let θ = Math.atan2(y, x);

    // 转换为0-360度
    return ((θ * 180) / Math.PI + 360) % 360;
  }

  randomRgbColor() {
    // 随机生成RGB颜色
    var r = Math.floor(Math.random() * 256);
    var g = Math.floor(Math.random() * 256);
    var b = Math.floor(Math.random() * 256);
    return `rgb(${r},${g},${b})`;
  }

  switchColor() {
    let n = Math.floor(Math.random() * 2) + 1;
    let c = "black";
    switch (n) {
      case 1:
        c = "red";
        break;
      case 2:
        c = "blue";
        break;
      case 3:
        c = "blueviolet";
        break;
      case 4:
        c = "orange";
        break;
      case 5:
        c = "pink";
        break;
      default:
        c = "yellow";
        break;
    }

    return "aquamarine";
  }

  toFixedValue(str, num = 6) {
    const value = +str;
    return value.toFixed(num).replace(/\.?0+$/, "");
  }

  getTimeRange(validTimestamps) {
    if (!Array.isArray(validTimestamps) || validTimestamps.length === 0) {
      return { earliest: null, latest: null };
    }

    // 转换为时间戳进行比较
    // const timestamps = timeArray.map((time) => new Date(time).getTime());
    // const validTimestamps = timestamps.filter((ts) => !isNaN(ts));

    if (validTimestamps.length === 0) {
      return { earliest: null, latest: null };
    }

    const earliest = new Date(Math.min(...validTimestamps));
    const latest = new Date(Math.max(...validTimestamps));

    return this.timestamp(earliest) + " " + this.timestamp(latest);
    // return { earliest: this.timestamp(earliest), latest: this.timestamp(latest) };
  }

  getMinMax(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return { min: null, max: null };
    }

    // 处理非数值元素
    const numbers = arr.filter((item) => typeof item === "number" && !isNaN(item));

    if (numbers.length === 0) {
      return { min: null, max: null };
    }
    return (+Math.min(...numbers)).toFixed(2) + " ~ " + (+Math.max(...numbers)).toFixed(2);
    // return {min: Math.min(...numbers),max: Math.max(...numbers)};
  }

  calculateNameAverage(nestedArray) {
    const sumMap = {};
    const countMap = {};

    // 遍历嵌套数组
    nestedArray.flat().forEach((item) => {
      if (item && item.name && !isNaN(parseFloat(item.value))) {
        const numValue = parseFloat(item.value);
        sumMap[item.name] = (sumMap[item.name] || 0) + numValue;
        countMap[item.name] = (countMap[item.name] || 0) + 1;
      }
    });

    // 转换为指定格式的输出
    return Object.keys(sumMap).map((name) => ({
      name,
      value: (sumMap[name] / countMap[name]).toString(),
    }));
  }

  handleArray(arr) {
    if (!Array.isArray(arr)) {
      throw new TypeError("参数必须是一个数组");
    }

    if (arr.length === 0) {
      return 0;
    }

    if (arr.length === 1) {
      return arr[0];
    }

    const sum = arr.reduce((acc, val) => acc + val, 0);
    return sum / arr.length;
  }
}
export default new Utils();
